<template>
  <ModalDefault modal_id="smsModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_714')"
                :footer="chat.new_sms.text.length > 2"
                icon="bx bx-mail-send mr-1">
    <div class="px-2 py-2 pb-2" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block px-2">
              <div class="col-12 pt-1 px-0">
                <div class="w-100 d-flex justify-content-between shadow-sm alert rounded-0 bg-light text-secondary">
                  <div>
                    <div>
                      <small>
                        {{ getLeadObject('id', chat.ticket.lead_id).name }}
                      </small>
                    </div>
                    <div>
                      <span class="title-color">
                        <i class="bx bx-phone-call mr-1"></i>
                        {{ getLeadObject('id', chat.ticket.lead_id).phone_hidden }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 pt-2 pb-0 px-1">
                <label class="mb-0">{{ getTranslations('expression_715') }}</label>
                <div class="input-group mb-1">
                  <textarea v-model="chat.new_sms.text"
                            rows="2"
                            maxlength="160"
                            style="resize: none"
                            class="input_forms form-control"
                  />
                </div>
                <div class="col-12 text-right px-0">
                  <TextCount :length="chat.new_sms.text.length" limit="160"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
            <span @click.prevent="sendSms" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <span class="">{{ getTranslations('expression_562') }}</span>
            </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import $ from "jquery";
import {mapGetters, mapState} from "vuex";
import TextCount from "../general/TextCount";

export default {
  name: "ModalChatSms",
  components: {
    TextCount,
    ModalDefault,
  },
  mounted() {
    $('#smsModal').on('hidden.bs.modal', () => {
      this.chat.new_sms.text = ""
    })
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getLeadObject',
    ])
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    sendSms(){
      const format = {
        text: this.chat.new_sms.text
      }
      this.chat.ui.row_textarea = 1
      this.chat.new_sms.channel_id = this.chat.ticket.channel_id
      this.chat.new_sms.ticket_id = this.chat.ticket.id
      this.chat.new_sms.text = `sms|${JSON.stringify(format)}`
      this.chat.new_sms.operator_id = this.isOperator(this.chat.ticket.department_id)
      this.chat.new_sms.department_id = this.chat.ticket.department_id
      this.$store.dispatch('sendMessage', this.chat.new_sms)
      this.chat.new_sms.text = "";
      this.chat.isShowEmoji = false;
      setTimeout(() => {
        this.$root.$emit('chatTextareaFocus')
        this.chat.new_sms = {
          text: "",
        }
      }, 200)
      $('#smsModal').modal('hide')
    },
  }
}
</script>

<style scoped>

</style>
